import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Field} from "../../models";

interface Category {
    name?: string;
    itemCount?: number;
    selectedItemCount?: number;
}

@Component({
    selector: 'app-query-variables',
    templateUrl: './query-variables.component.html',
    styleUrls: ['./query-variables.component.scss']
})
export class QueryVariablesComponent implements OnInit {
    @Input() showTitle? = true;
    @Input() stepIndex = 3;
    @Input() datasetCode!: string;
    @Output() filterChange = new EventEmitter<any>();
    _fieldList: Field[] = [];
    @Input() set fieldList(list: Field[]) {
        this._fieldList = list;
        this.variableToSelectList = [...list];
        this.categoryList = Array.from(new Set(list.map((item: any) => item?.category))).map((categoryName: any) => ({
            name: categoryName,
            itemCount: list.filter((item: any) => item?.category === categoryName).length,
            selectedItemCount: 0
        }));
    }
    get fieldList() {
        return this._fieldList;
    }
    @Output() variableListChange = new EventEmitter<any>();
    @Input() variableToSelectList?: Field[] = [];
    @Input() variableSelectedList?: Field[] = [];
    categoryList: Category[] = [];
    allCategory: Category = {
        name: '',
        itemCount: 0,
        selectedItemCount: 0
    }
    selectedCategory: Category = this.allCategory;
    searchInput: string = '';

    constructor() {
    }

    ngOnInit() {
    }

    updateVariableToSelectList() {
        this.variableToSelectList = this.fieldList
            .filter(item => !this.variableSelectedList?.some(user =>
                JSON.stringify(user) === JSON.stringify(item)
            ))
            .filter(item => !this.selectedCategory?.name || item?.category === this.selectedCategory?.name)
            .filter(item => item?.fieldKey?.toLowerCase().includes(this.searchInput.toLowerCase()));
    }

    updateCategorySelectedCount() {
        this.categoryList.forEach(category => {
            category.selectedItemCount = this.variableSelectedList?.filter(item => item.category === category.name).length;
        });
    }

    searchVariableByCategory() {
        this.updateVariableToSelectList();
    }

    searchVariableByName() {
        this.updateVariableToSelectList();
    }

    selectAllVariables() {
        this.variableSelectedList = [...this.variableSelectedList || [], ...this.variableToSelectList || []];
        this.updateVariableToSelectList();
        this.updateCategorySelectedCount();
        this.onVariableListChange(this.variableSelectedList);
    }

    unselectAllVariables() {
        this.variableSelectedList = [];
        this.updateVariableToSelectList();
        this.updateCategorySelectedCount();
        this.onVariableListChange(this.variableSelectedList);
    }

    selectVariable(variable: Field) {
        this.variableSelectedList?.push(variable);
        this.updateVariableToSelectList();
        this.updateCategorySelectedCount();
        this.onVariableListChange(this.variableSelectedList || []);
    }

    unselectVariable(variable: Field) {
        this.variableSelectedList = this.variableSelectedList?.filter(item => item !== variable);
        this.updateVariableToSelectList();
        this.updateCategorySelectedCount();
        this.onVariableListChange(this.variableSelectedList || []);
    }

    onVariableListChange(event: Field[]) {
        this.variableListChange.emit(event);
    }
}
